import React from 'react';
import { Section } from './Section';
import { Check, X } from 'lucide-react';
const forWho = ['Emprendedores solistas que sienten que el día se les escapa entre los dedos.', 'Profesionales remotos con exceso de reuniones y falta de avance real.', 'Creadores y técnicos que necesitan periodos largos de concentración profunda.', 'Personas cansadas de la motivación barata que buscan una estructura fría y ejecutable.'];
const notForWho = ['Personas que buscan "hacks" mágicos sin querer apagar el celular.', 'Quienes prefieren parecer ocupados que ser productivos.', 'Gente que no está dispuesta a proteger sus bloques de tiempo frente a terceros.'];
export function WhoIsItForSection() {
  return <Section data-id="element-120">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-121">
        {/* PARA QUIÉN ES */}
        <div className="bg-tactical-light border border-green-500/20 p-8 md:p-10" data-id="element-122">
          <h2 className="text-2xl md:text-3xl font-bold text-white uppercase mb-8 flex items-center justify-center gap-3 text-center" data-id="element-123">
            <Check className="w-8 h-8 text-green-500" data-id="element-124" />
            Para quién es
          </h2>
          <ul className="space-y-6" data-id="element-125">
            {forWho.map((item, idx) => <li key={idx} className="flex flex-col items-center text-center gap-2" data-id="element-126">
                <Check className="w-6 h-6 text-green-500 shrink-0" data-id="element-127" />
                <span className="text-zinc-300 text-lg" data-id="element-128">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* PARA QUIÉN NO ES */}
        <div className="bg-tactical-light border border-red-500/20 p-8 md:p-10" data-id="element-129">
          <h2 className="text-2xl md:text-3xl font-bold text-white uppercase mb-8 flex items-center justify-center gap-3 text-center" data-id="element-130">
            <X className="w-8 h-8 text-red-500" data-id="element-131" />
            Para quién NO es
          </h2>
          <ul className="space-y-6" data-id="element-132">
            {notForWho.map((item, idx) => <li key={idx} className="flex flex-col items-center text-center gap-2" data-id="element-133">
                <X className="w-6 h-6 text-red-500 shrink-0" data-id="element-134" />
                <span className="text-zinc-400 text-lg" data-id="element-135">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}